<template>
  <div id="container">
    <div class="product-status">
      <div class="bold"></div>
      <el-tabs
        v-model="activeName"
        @tab-click="handleClick">
        <el-tab-pane
          :label="item.title"
          :name="item.name"
          class="tab-text"
          v-for="item in transferList"
          :key="item.name"
        ></el-tab-pane>
      </el-tabs>
    </div>
    <div class="search-style">
      <el-form :model="queryParams">
        <el-row :gutter="24">
          <el-col :span="24">
            <el-col :span="4">
              <el-form-item>
                <el-select v-model="queryParams.expressionex">
                  <el-option
                    :label="item.label"
                    :value="item.value"
                    :disabled="item.disabled"
                    v-for="(item,index) in expressionList"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <el-date-picker
                  style="width:100%;"
                  type="daterange"
                  v-model="queryParams.createDate"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00','23:59:59']"
                  v-if="queryParams.expressionex === 'createDate' || queryParams.expressionex === 'lastDate'"
                ></el-date-picker>
                <el-input
                  v-else
                  v-model="queryParams.value"
                  clearable
                  placeholder="请输入关键词"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <el-button
                  type="primary"
                  @click="onSearch">搜索
                </el-button>
                <el-button @click="resetForm()">重置</el-button>
              </el-form-item>
            </el-col>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="background-color: #fff">
      <div
        class="box-table"
        :style="{height:tableHeight + 'px'}">
        <el-table
          ref="custromTableRef"
          style="cursor: pointer"
          :data="tableData"
          tooltip-effect="dark"
          :header-cell-style="tableHeader"
          @row-click="gotoCheckView"
          v-loading="loadingTable"
          element-loading-text="拼命加载中请稍后..."
          element-loading-spinner="el-icon-loading"
          border
          :max-height="tableHeight"
        >
          <el-table-column
            prop="bizType"
            label="待办内容">
            <template v-slot="{ row }">{{row.bizTitle}} {{row.bizType}}</template>
          </el-table-column>
          <el-table-column
            prop="createDate"
            label="发起时间"
            width="150">
            <template slot-scope="scope">{{scope.row.createDate | formatData}}</template>
          </el-table-column>
          <el-table-column
            v-if="activeName === 'b'"
            prop="lastDate"
            label="处理时间"
            width="150">
            <template slot-scope="scope">{{scope.row.lastDate | formatData}}</template>
          </el-table-column>
        </el-table>
      </div>
      <Pagination
        :query.sync="query"
        @refresh="refreshPage"></Pagination>
    </div>
  </div>
</template>

<script>
import { isSuccess } from '@/util/tool'
import Pagination from '@/components/module/Pagination'
import { creatBasePageData } from '@/util/date'
import backlogApi from '@/api/workbench/backlog'
import { deepClone } from '@/util'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'inform',
  data () {
    return {
      tableHeight: window.innerHeight - 380,
      queryParams: {
        createDate: [],
        expressionex: 'bizTitle',
        value: ''
      },
      query: { ...creatBasePageData() },
      transferList: [{
        title: '我的待办',
        name: 'a'
      }, {
        title: '已完成',
        name: 'b'
      }],
      activeName: 'a',
      backlogListData: [],
      expressionList: [
        {
          value: 'bizTitle',
          label: '待办内容'
        },
        {
          value: 'createDate',
          label: '发起时间'
        }
      ],
      tableData: [],
      backlogQuery: {
        ...creatBasePageData(),
        criteriaVoList: [
          {
            collection: true,
            column: '',
            endValue: '',
            expression: '',
            value: '',
            valueType: ''
          }
        ],
        queryPageName: ''
      },
      loadingTable: false
    }
  },
  components: {
    Pagination
  },
  computed: {
    ...mapState(['backlogActiveName'])
  },
  watch: {
    activeName (newVal) {
      if (newVal === 'b') {
        this.expressionList = [
          {
            value: 'bizTitle',
            label: '待办内容'
          },
          {
            value: 'createDate',
            label: '发起时间'
          },
          {
            value: 'lastDate',
            label: '处理时间'
          }
        ]
      } else {
        this.expressionList = [
          {
            value: 'bizTitle',
            label: '待办内容'
          },
          {
            value: 'createDate',
            label: '发起时间'
          }
        ]
      }
      return newVal
    }
  },
  mounted () {
    // 待办列表
    this.activeName = this.backlogActiveName
    this.refreshPage()
  },
  methods: {
    ...mapMutations(['setBacklogActiveName']),
    refreshPage () {
      if (this.activeName === 'a') {
        this.getBacklogList()
      } else {
        this.getBackLogSucList()
      }
    },
    onSearch () {
      const {
        queryParams
      } = this
      let value = queryParams.value
      if (queryParams.expressionex === 'createDate' || queryParams.expressionex === 'lastDate') {
        if (queryParams.createDate) {
          value = queryParams.createDate[0] || ''
        } else {
          value = ''
        }
      }
      if (!value) {
        this.$message.error('请输入搜索条件')
        return
      }
      if (this.activeName === 'a') {
        this.getBacklogList()
      } else {
        this.getBackLogSucList()
      }
    },
    gotoCheckView (row) {
      const {
        bizFormUrl,
        bizId
      } = row
      if (bizFormUrl) {
        this.$router.push({
          name: bizFormUrl,
          query: {
            bizId: bizId.toString()
          }
        })
      }
    },
    // 待办已完成列表
    getBackLogSucList () {
      backlogApi.getBackLogSucList(this.formatParams()).then(res => {
        if (isSuccess(res)) {
          this.tableData = res.data.obj.records
          this.setQueryData(res, 'query')
          this.loadingTable = false
        }
      })
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    handleClick () {
      this.setBacklogActiveName(this.activeName)
      this.query = deepClone({
        ...creatBasePageData()
      })
      Object.assign(this.queryParams, {
        expressionex: 'bizTitle',
        createDate: []
      })
      this.refreshPage()
    },
    formatParams () {
      this.loadingTable = true
      const {
        query,
        queryParams
      } = this
      let value = queryParams.value
      if (queryParams.expressionex === 'createDate' || queryParams.expressionex === 'lastDate') {
        if (queryParams.createDate) {
          value = queryParams.createDate[0] || ''
        } else {
          value = ''
        }
      }
      const params = {
        criteriaVoList: [{
          collection: true,
          column: queryParams.expressionex,
          endValue: queryParams.createDate[1] || '',
          expression: '',
          value,
          valueType: ''
        }],
        queryPageName: ''
      }
      return {
        ...query,
        ...params
      }
    },
    getBacklogList () {
      backlogApi.getBacklogList(this.formatParams()).then(res => {
        if (isSuccess(res)) {
          this.tableData = res.data.obj.records
          this.setQueryData(res, 'query')
          this.loadingTable = false
        }
      })
    },
    setQueryData (res, queryField) {
      const {
        current,
        size,
        total
      } = res.data.obj
      this[queryField] = Object.assign(this[queryField], {
        page: current,
        size,
        total
      })
    },
    resetForm () {
      this.queryParams = {
        createDate: [],
        expressionex: 'bizTitle',
        value: ''
      }
      this.refreshPage()
    }
  }
}
</script>

<style scoped>
  .product-status .bold {
    top: 10px;
  }

  .noticelisttask {
    font-size: 14px;
  }

  .noticelisttask span {
    color: #d35e5e;
  }

  b.red {
    color: #d35e5e;
  }
</style>
